export const UPDATE_MODE = 'UPDATE_MODE'
export const REFRESH_CONFIG = 'REFRESH_CONFIG'

export const updateMode = (mode = 'concession') => ({
  type: UPDATE_MODE,
  payload: { mode }
})

export const refreshConfig = () => ({
  type: REFRESH_CONFIG,
})
